"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const general_1 = require("../../general");
const buildError_1 = tslib_1.__importDefault(require("../errorHandling/buildError"));
const handleServerError_1 = tslib_1.__importDefault(require("../errorHandling/handleServerError"));
/**
 * A utility function to make api calls that throws standardized errors.
 * @param {string} url - url of the api to be accessed
 * @param {object} options - an object containing any options to pass into the api call (eg. headers, credentials, etc...)
 * @returns {Promise} a promise if successful or throws an error object.
 */
const fetchClient = async (url, options) => {
    var _a;
    const defaultConfig = {
        url,
        method: 'get'
    };
    const config = Object.assign(Object.assign({}, defaultConfig), options);
    if (!config.headers) {
        config.headers = {};
    }
    if (config.headers['correlation-id'] === undefined) {
        config.headers['correlation-id'] = `kd-${(0, general_1.getGuidOrGenerate)(null)}`;
    }
    try {
        const res = await (0, axios_1.default)(Object.assign({}, config));
        return res;
    }
    catch (error) {
        const err = error;
        if (err === null || err === void 0 ? void 0 : err.isAxiosError) {
            const axiosResponse = err.response;
            if (axiosResponse) {
                const { status, data } = axiosResponse;
                throw (0, buildError_1.default)(status, (_a = data === null || data === void 0 ? void 0 : data.message) !== null && _a !== void 0 ? _a : data === null || data === void 0 ? void 0 : data.response, url, options, undefined, data);
            }
        }
        (0, handleServerError_1.default)(error, url, options);
    }
};
exports.default = fetchClient;
//# sourceMappingURL=fetchClient.js.map